import type {BottomTabName} from '@libs/Navigation/types';
import SCREENS from '@src/SCREENS';

const BOTTOM_TAB_SCREENS: BottomTabName[] = [SCREENS.HOME, SCREENS.SETTINGS.ROOT];

export default BOTTOM_TAB_SCREENS;
